module.exports = __webpack_public_path__ + "img/facebook.f128db8b.svg";